import ApiService from '@/services/api'
import { defineStore } from 'pinia'

const ENDPOINT = '/contacts/'
const ITEM_ID  = 'ctt_id'

export const useContactStore = defineStore('contacts', {
  state: () => ({
    item: { ctt_sta_id: 'GEN01', ctt_typ_id: 'CTT01', ctt_firstname: '', ctt_lastname: '', ctt_customfields: {} },
    itemList: [],
    metaItems: null
  }),
  getters: {},
  actions: {
    fetchItem (id, options) {
      return new Promise((resolve, reject) => {
        options = (options) ? '/' + options : ''
        if (id && id > 0) {
          ApiService.get(ENDPOINT + id + options).then((response) => {
            if (!response.data.data.ctt_customfields || Object.prototype.toString.call(response.data.data.ctt_customfields) === '[object Array]') {
              response.data.data.ctt_customfields = {}
            }
            this.SET_ITEM(response.data.data)
            resolve(this.item)
          }).catch((error) => { reject(error) })
        } else {
          this.RESET_ITEM()
          resolve(this.item)
        }
      })
    },
    fetchItems (options) {
      return new Promise((resolve, reject) => {
        ApiService.get(ENDPOINT + (options || '')).then((response) => {
          this.metaItems = response.data.meta
          if (Object.prototype.toString.call(response.data.data) === '[object Array]') {
            this.SET_ITEMS(response.data.data)
          }
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    storeItem () {
      return new Promise((resolve, reject) => {
        ApiService.post(ENDPOINT, this.item).then((response) => {
          this.SET_ITEM(response.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    updateItem () {
      return new Promise((resolve, reject) => {
        ApiService.put(ENDPOINT + this.item[ITEM_ID], this.item).then((response) => {
          this.SET_ITEM(response.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    destroyItem (id) {
      return new Promise((resolve, reject) => {
        this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
        ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then(() => {
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) {
      if (item && (!item.ctt_customfields || Object.prototype.toString.call(item.ctt_customfields) === '[object Array]')) {
        item.ctt_customfields = {}
      }
      this.item = item || {}
    },
    SET_ITEMS (itemList) {
      itemList.forEach(element => {
        element.ctt_customfields = (!element.ctt_customfields) ? {} : element.ctt_customfields
      })
      this.itemList = itemList
    },
    RESET_ITEM () { this.item = { ctt_sta_id: 'GEN01', ctt_typ_id: 'CTT01', ctt_customfields: {} } }
  }
})
